import { createContext } from 'react';

const pracUserAvailabilityContext = createContext();
export default pracUserAvailabilityContext;
